<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>



<div class="modal-signup modal-content max-width-80pe border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

        <div class="row" *ngIf="SelectedpatientDetails">
          <div class="col-md-2 ">
            <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.OwnerPatientImageFile" onError="this.src='dummy.jpg';">
          </div>
          <div class="col-md-4 padding-left-0px">
            <div class="row row-height-17px margin-left-0px">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.OwnerName}} </label>
              </div>
            </div>
            <div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(for : {{SelectedpatientDetails.EggName}}) </label>
              </div>
            </div>
            <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
              </div>
            </div>-->
            <div class="row row-height-17px">
              <div class="col-md-12">

                <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.OwnerAgeYears}},{{SelectedpatientDetails.OwnerFormattedCode}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-4">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.OwnerTelephone1}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-3 padding-right-0px">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">Cycle#{{SelectedpatientDetails.CycleNo}},</label>
              </div>
              <div class="col-md-9 padding-left-0px">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">Start Date: {{SelectedpatientDetails.ProtocolStartDate | date:'MMM-dd-yyyy'}}</label>
              </div>

            </div>

          </div>
          <div class="col-md-5  padding-right-0px">
            <!--<div class="row font-size-12px">
              <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
              </div>:
              <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="FollicularData2">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularData2.LastUpdatedTime | date: 'hh:mm a'}}</label>
              </div>
            </div>-->
            <div class="row font-size-12px">
              <div class="col-md-7 margin-left-auto text-align-right padding-right-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
              </div>:
              <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="InseminationData2">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">{{InseminationData2.ActivityStatus}}</label>
              </div>
            </div>
            <!--<div class="row font-size-12px" *ngIf="FollicularPickupEndInfo">
              <div class="col-md-7 margin-left-auto text-align-right padding-right-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Pickup Date </label>
              </div>:
              <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="FollicularPickupEndInfo">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularPickupEndInfo.OvumPickupdate | date:'MMM-dd-yyyy'}}</label>
              </div>
            </div>-->
            <!--<div class="row">
              <div class="col-md-1 margin-left-auto padding-left-7px">
                <div class=""><label class="margin-bottom-0px font-weight-normal">D</label></div>
                </div>
              <div class="col-md-1 padding-left-7px">
                <div class=""><label class="margin-bottom-0px font-weight-normal">S</label></div>
              </div>

               <div class="col-md-1 padding-left-7px">

                <div class=""><label class="margin-bottom-0px font-weight-normal">A</label></div>
              </div>

            </div>-->
            <div class="row margin-right-0px" hidden>
              <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
              </div>
              <div class="Dsa2" *ngIf="DSADetails">
                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
              </div>
              <div class="Dsa3" *ngIf="DSADetails">

                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
              </div>

            </div>
          </div>
          <div class="col-md-1">
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.close('Load')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <!--{{ sectionData.Title }}-->


      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px padding-left-0px">
        <div class="card">

          <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
            <div class="row nav-link-hand margin-right-0px margin-left-0px" id="edit-link">
              <div class="col-md-6 padding-right-0px">
                <label class="margin-bottom-0px font-size-16px font-weight-normal">
                  Insemination
                </label>
              </div>
              <div class="col-md-5  padding-right-0px " *ngIf="GradingModel && SelectedpatientDetails">
                <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                <div class="row float-right" *ngIf="GradingModel=='Well Culture'">
                  <div class="col-md-10 margin-top-3px padding-left-0px" *ngIf="InseminationData2">
                    <!--<a class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>-->
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="Insemination()" title="Is Insemination Completed" *ngIf="InseminationData2.ActivityStatus !=='Completed'">Is Insemination Completed</a>
                  </div>

                  <!--<div class="col-md-1">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printinsemi()">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>-->
                </div>

                <div class="row float-right" *ngIf="GradingModel=='Droplet Culture' && SelectedpatientDetails.CycleType!=='IUI'">
                  <div class="col-md-12 margin-top-3px padding-left-0px" *ngIf="InseminationData2">
                    <!--<a class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>-->
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="Insemination()" title="Is Insemination Completed" *ngIf="InseminationData2.ActivityStatus !=='Completed'">Is Insemination Completed</a>
                  </div>

                  <!--<div class="col-md-1">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printinsemidroplet()">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>-->
                </div>
                <div class="row float-right" *ngIf="GradingModel=='Droplet Culture' && SelectedpatientDetails.CycleType=='IUI'">
                  <div class="col-md-12 margin-top-3px padding-left-0px" *ngIf="InseminationData2">
                    <!--<a class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>-->
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="InseminationIUI()" title="Is Insemination Completed" *ngIf="InseminationData2.ActivityStatus !=='Completed'">Is Insemination Completed</a>
                  </div>

                  <!--<div class="col-md-1">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printinsemidroplet()">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>-->
                </div>

              </div>

            </div>
          </div>
          <div class="chatsd product-chart-wrapper product-chat-follicular-popup agreement-chart-wrapper ps  padding-lrt " data-ps-id="dfsfsde">
            <div class="card-body" *ngIf="GradingModel">
              <div class="accordion margin-bottom-20px margin-top-20px" id="accordionExampleOocyte" *ngIf="GradingModel=='Well Culture'">
                <div class="card margin-bottom-5px">
                  <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOocyte">
                    <div class="row">
                      <div class="col-md-4 padding-right-0px">
                        <h5 class="mb-0 height-24px margin-top-5px">
                          <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOocyte" aria-expanded="true" aria-controls="collapseOocyte">
                            Oocytes for Insemination
                          </button>
                        </h5>
                      </div>
                      <div class="col-md-1 padding-left-0px">
                        <div class="badge badge-search padding-right-7px padding-left-7px"><h4 class="margin-bottom-0px margin-top-1px">{{length}}</h4></div>
                      </div>
                      <div class="col-md-7 ">
                        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                        <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" hidden>Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                      </div>
                    </div>


                  </div>

                  <div id="collapseOocyte" class="collapse show" aria-labelledby="headingOocyte" data-parent="#accordionExampleOocyte">
                    <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                      <div class="row">
                        <div class="col-md-12 padding-left-0px" *ngIf="GradingModel">
                          <div class="table-component" *ngIf="GradingModel=='Well Culture'">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero overflow-y-hidden">

                                <thead class="">
                                  <tr>
                                    <th class="min-width-0px padding-top-4px padding-bottom-4px"></th>

                                    <th class="padding-top-4px padding-bottom-4px">Sno</th>
                                    <th class="padding-top-4px padding-bottom-4px">Well#</th>
                                    <th class="padding-top-4px padding-bottom-4px">Occ/Denuded</th>
                                    <th class="padding-top-4px padding-bottom-4px">Morphology</th>
                                    <th class="white-space-preline padding-top-4px padding-bottom-4px">Technique</th>
                                    <th class="padding-top-4px padding-bottom-4px" *ngIf="InseminationData2.ActivityStatus !=='Completed'"></th>
                                  </tr>
                                </thead>
                                <tbody class="table-body">
                                  <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                  <!--</ng-container>-->
                                  <tr *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">
                                    <td class="td-padding padding-all-0px ">

                                      <input type="checkbox" name="l.IsSelected"
                                             [(ngModel)]="l.IsSelected">
                                      <i class="input-helper"></i>

                                    </td>

                                    <td class="text-align-center padding-all-0px">{{i+1}}</td>
                                    <td class="text-align-center padding-all-0px">{{l.WellNo}}</td>
                                    <td class="td-padding padding-all-0px text-align-center">{{l.OocyteQualityPre}}/{{l.OocyteQualityPost}}</td>
                                    <td class="td-padding padding-all-0px text-align-center">{{l.Morphology}}</td>
                                    <td class="padding-all-0px">
                                      <CodeTypeValue CodeType="InsTe" [(ngModel)]="l.technique" SelectedValue="l.technique"
                                                     required></CodeTypeValue>
                                    </td>

                                    <td class="text-align-center padding-all-0px" *ngIf="InseminationData2.ActivityStatus !=='Completed'">
                                      <button type="submit" (click)="onSubmit(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l?.IsSelected"><i class="far fa-save"></i></button>


                                    </td>



                                  </tr>
                                </tbody>

                              </table>

                            </div>
                          </div>
                          <div class="table-component" *ngIf="GradingModel=='Droplet Culture'">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero overflow-y-hidden">

                                <thead class="">
                                  <tr>
                                    <th class="min-width-0px padding-top-4px padding-bottom-4px"></th>

                                    <th class="width100px">
                                      Group ID
                                    </th>


                                    <th class="td-well-width-79px">
                                      ID
                                    </th>
                                    <th class="padding-top-4px padding-bottom-4px">Occ/Denuded</th>
                                    <th class="padding-top-4px padding-bottom-4px">Morphology</th>
                                    <th class="white-space-preline padding-top-4px padding-bottom-4px">Technique</th>
                                    <th class="padding-top-4px padding-bottom-4px" *ngIf="InseminationData2.ActivityStatus !=='Completed'"></th>
                                  </tr>
                                </thead>
                                <tbody class="table-body">
                                  <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                  <!--</ng-container>-->
                                  <tr *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">
                                    <td class="td-padding padding-all-0px ">

                                      <input type="checkbox" name="l.IsSelected"
                                             [(ngModel)]="l.IsSelected">
                                      <i class="input-helper"></i>

                                    </td>
                                    <td class="padding-all-0px text-align-center width-th-52px">


                                      <CodeTypeValue CodeType="EMGRP"
                                                     required>
                                      </CodeTypeValue>

                                    </td>
                                    <td class="padding-all-0px">


                                      <input type="text" class="form-control" placeholder=""
                                             maxlength="2" required>
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Well.valid && (Well.dirty || Well.touched) && Well.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Well.valid && Well.errors.pattern)">(special characters are not allowed)</small>-->
                                    </td>

                                    <td class="td-padding padding-all-0px text-align-center">{{l.OocyteQualityPre}}/{{l.OocyteQualityPost}}</td>
                                    <td class="td-padding padding-all-0px text-align-center">{{l.Morphology}}</td>
                                    <td class="padding-all-0px">
                                      <CodeTypeValue CodeType="InsTe" [(ngModel)]="l.technique" SelectedValue="l.technique"
                                                     required></CodeTypeValue>
                                    </td>

                                    <td class="text-align-center padding-all-0px" *ngIf="InseminationData2.ActivityStatus !=='Completed'">
                                      <button type="submit" (click)="onSubmit(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l?.IsSelected"><i class="far fa-save"></i></button>


                                    </td>



                                  </tr>
                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div class="card margin-top-10" *ngIf="GradingModel=='Well Culture'">
                <!--<div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
                  <div class="row nav-link-hand margin-right-0px" id="edit-link">
                    <div class="col-md-6 padding-right-0px">
                      <label class="margin-bottom-0px font-size-16px font-weight-normal">
                        Insemination Log
                      </label>
                    </div>
                    <div class="col-md-6  padding-right-0px display-edit">

                      <div class="row float-right">

                        <div class="col-md-1">
                          <a class="nav-link-hand education-navlink data-color-new" title="print">
                            <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                          </a>
                        </div>
                      </div>




                    </div>

                  </div>
                </div>-->
                <div class="card-body padding-all-0px">
                  <div class="accordion margin-bottom-20px margin-top-10" id="accordionExampleLog">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingLog">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseLog" aria-expanded="true" aria-controls="collapseLog">
                                Insemination Log
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="InseminationData2">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="button"
                                    class="btn  btn-sm button-ivfactivity  background-primary border-all-secondary float-right" id="FileUpload" (click)="Addactivity()"
                                    name="upload" *ngIf="InseminationData2.ActivityStatus !=='Completed'">
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                          </div>
                        </div>


                      </div>

                      <div id="collapseLog" class="collapse show" aria-labelledby="headingLog" data-parent="#accordionExampleLog">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="card margin-bottom-0px background-lightpink">

                                <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                  <div class="table-component margin-bottom-0px padding-all-5px">
                                    <div class="table-responsive">


                                      <table class="table table-striped margin-left-zero overflow-y-hidden">

                                        <thead class="">
                                          <tr>
                                            <th class="min-width-0px">Date &amp; Time</th>

                                            <th class="min-width-0px">No of times per hour</th>
                                            <th class="padding-left-5px">Processed By</th>

                                            <th>Doctor</th>
                                            <th></th>
                                          </tr>
                                        </thead>
                                        <tbody class="table-body">

                                          <tr *ngFor="let l of CurrentIvfCycleInseminationLogByCycleWithDOCController">
                                            <td class="td-padding">


                                              {{l.InseminationDate| date:'dd-MMM-yyyy'}} &amp; {{l.InseminationTime| date: 'mediumTime'}}

                                            </td>
                                            <td class="td-padding text-align-center">

                                              {{l.NtimesInformed}}


                                            </td>

                                            <td class="td-padding ">

                                              {{l.ProcessedByName}}
                                            </td>
                                            <td class="td-padding text-align-center white-spce-pre">
                                              <div class="broder-right-1px-dark">{{l.DoctorName}}</div>
                                              <div>{{l.NurseName}}</div>
                                            </td>



                                            <td>
                                              <div class="test-icons float-right" *ngIf="InseminationData2">
                                                <a (click)="Addactivity()" class="nav-link-hand" title="Remove" *ngIf="InseminationData2.ActivityStatus !=='Completed'"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                                <a (click)="Editactivity(l)" class="nav-link-hand education-navlink  color-Assign" title="Edit" *ngIf="InseminationData2.ActivityStatus !=='Completed'">
                                                  <span class="badge"><i class="fas fa-pencil-alt nav-link-hand"></i></span>
                                                </a>
                                              </div>
                                            </td>

                                          </tr>


                                        </tbody>

                                      </table>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
              <div class="accordion" id="accordionExampleStorage" *ngIf="GradingModel=='Well Culture'">

                <div class="card margin-bottom-5px">
                  <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingStorage">
                    <div class="row">
                      <div class="col-md-4">
                        <h5 class="mb-0 height-24px">
                          <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseStorage" aria-expanded="true" aria-controls="collapseStorage">
                            Oocytes For Storage
                          </button>
                        </h5>
                      </div>
                      <div class="col-md-8">
                        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                        <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                      </div>
                      <!--<div class="col-md-6">
                        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                        <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                      </div>-->
                    </div>


                  </div>

                  <div id="collapseStorage" class="collapse show" aria-labelledby="headingStorage" data-parent="#accordionExampleStorage">
                    <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                      <div class="card margin-bottom-0px margin-top-10">

                        <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                          <div class="row margin-bottom-10px" *ngIf="CurrentIvfOocyteEmbryoStorageByCodeController ==null || CurrentIvfOocyteEmbryoStorageByCodeController.length == 0">
                            <!--<button (click)="Store()" class="btn font-size-13px actions-btn-prime margin-left-auto margin-right-auto">Init Store</button>-->
                          </div>
                          <div class="row">
                            <div class="col-md-12 ">
                              <div class="table-component" *ngIf="GradingModel=='Well Culture'">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero overflow-y-hidden">

                                    <thead class="">
                                      <tr>
                                        <th class="min-width-0px padding-top-4px padding-bottom-4px"></th>


                                        <th class="padding-top-4px padding-bottom-4px">Well#</th>

                                        <th class="padding-top-4px padding-bottom-4px">Morphology</th>
                                        <th class="white-space-preline padding-top-4px padding-bottom-4px">Storage</th>
                                        <th class="padding-top-4px padding-bottom-4px">Details</th>
                                        <th class="padding-top-4px padding-bottom-4px padding-right-0px">Status</th>
                                        <th class="padding-top-4px padding-bottom-4px padding-left-0px padding-right-0px" *ngIf="InseminationData2.ActivityStatus !=='Completed'"></th>
                                      </tr>
                                    </thead>
                                    <tbody class="table-body">
                                      <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                      <!--</ng-container>-->
                                      <tr *ngFor="let l of CurrentIvfOocyteEmbryoStorageByCodeController">
                                        <td class="td-padding padding-all-0px ">

                                          <input type="checkbox" name="l.IsSelected"
                                                 [(ngModel)]="l.IsSelected">
                                          <i class="input-helper"></i>

                                        </td>


                                        <td class="text-align-center padding-all-0px">{{l.WellNo}}</td>

                                        <td class="padding-top-0px padding-bottom-0px">{{l.Morphology}}</td>

                                        <td class="padding-all-0px text-align-center">
                                          <!--<CodeTypeValue CodeType="OST" [(ngModel)]="l.StorageUnitType" SelectedValue="l.StorageUnitType"
                                          required></CodeTypeValue>-->
                                          {{l.StorageUnitType}}
                                        </td>
                                        <td class="padding-top-0px padding-bottom-0px">
                                          <!--<input type="text" class="form-control" min="1" max="10" placeholder="Details"
                                                 id="l.StorageUnitDetails"
                                                 [(ngModel)]="l.StorageUnitDetails"
                                                 name="l.StorageUnitDetails" #Remarks="ngModel"
                                                 maxlength="100">
                                          <small class="form-text text-danger"
                                                 *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                          <small class="form-text text-danger"
                                                 *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>-->
                                          {{l.StorageUnitDetails}}
                                        </td>
                                        <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px padding-right-0px">
                                          <a class="color-datacolor font-weight-normal text-decoration font-size-14">
                                            <i class="fas fa-circle color-Assign nav-link-hand  ">
                                            </i>
                                          </a>
                                        </td>
                                        <td class="padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px" *ngIf="InseminationData2.ActivityStatus !=='Completed'">
                                          <button type="submit" (click)="onSubmit2(l)" class="actions-btn-prime-insemination nav-link-hand float-right" title="Save" *ngIf="l?.IsSelected">Select For Insemination</button>


                                        </td>



                                      </tr>
                                    </tbody>

                                  </table>

                                </div>
                              </div>

                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                  </div>
                </div>


              </div>
              <div class="accordion margin-bottom-20px margin-top-10" id="accordionExampledrop1" *ngIf="GradingModel=='Droplet Culture'">
                <div class="card margin-bottom-5px">
                  <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingdrop1">
                    <div class="row">
                      <div class="col-md-4">
                        <h5 class="mb-0 height-24px">
                          <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsedrop1" aria-expanded="true" aria-controls="collapsedrop1">
                            Insemination
                          </button>
                        </h5>
                      </div>
                      <div class="col-md-8 " *ngIf="InseminationData2">
                        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                        <button type="button" (click)="AddInsemination()"
                                class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" *ngIf="InseminationData2.ActivityStatus !=='Completed'"
                                name="upload">
                          <i class="fas fa-plus font-size-11"></i>
                        </button>
                      </div>
                    </div>


                  </div>

                  <div id="collapsedrop1" class="collapse show" aria-labelledby="headingdrop1" data-parent="#accordionExampledrop1">
                    <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="card margin-bottom-0px">

                            <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                              <div class="table-component margin-bottom-0px padding-all-5px">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero overflow-y-hidden">
                                    <thead class="">
                                      <tr>
                                        <th class="padding-top-4px padding-bottom-4px font-size-12px">Technique</th>
                                        <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px">Injected/Inseminated</th>

                                        <th class="padding-top-4px padding-bottom-4px font-size-12px">Details</th>
                                        <th class="padding-top-4px padding-bottom-4px font-size-12px">Embryologist</th>
                                        <th class="td-well-width-79px padding-top-4px padding-bottom-4px"></th>
                                      </tr>
                                    </thead>

                                    <tbody class="table-body">
                                      <tr *ngFor="let l of CurrentIvfCycleInseminationByCycleController">
                                        <td class="padding-top-0px padding-bottom-0px ">


                                          <!--<CodeTypeValue CodeType="InsTe"
                                                         id="l.Technique"
                                                         [(ngModel)]="l.Technique" SelectedValue="l.Technique"
                                                         name="l.Technique" required>
                                          </CodeTypeValue>-->
                                          <label class="margin-bottom-0px">{{l.Technique}}</label>
                                        </td>
                                        <td class="padding-top-0px padding-bottom-0px text-align-center">
                                          <!--<input type="text" class="form-control text-align-right" placeholder=""
                                          [(ngModel)]="l.OocyteCount"
                                          maxlength="2" required>-->
                                          <label class="margin-bottom-0px">{{l.OocyteCount}}</label>
                                        </td>


                                        <td class="padding-top-0px padding-bottom-0px">
                                          <!--<input type="text" class="form-control" placeholder=""
                                          [(ngModel)]="l.Remarks"
                                          maxlength="2" required>-->
                                          <label class="margin-bottom-0px">{{l.Remarks}}</label>
                                        </td>
                                        <td class="padding-top-0px padding-bottom-0px">
                                          <!--<input type="text" class="form-control" placeholder=""
                                          [(ngModel)]="l.PrescribedByName"
                                          maxlength="2" required>-->
                                          <label class="margin-bottom-0px">{{l.PrescribedByName}}</label>
                                        </td>
                                        <td class="padding-all-0px">
                                          <div class="test-icons" *ngIf="InseminationData2">
                                            <a class="font-size-16px color-Assign" (click)="Editinsemi(l)"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand" *ngIf="InseminationData2.ActivityStatus !=='Completed'"></i></a>
                                            <!--<a class="nav-link-hand font-size-20px margin-left-15px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand" *ngIf="InseminationData2.ActivityStatus !=='Completed'"></i></a>-->
                                          </div>
                                        </td>
                                      </tr>

                                    </tbody>
                                  </table>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card margin-top-10" *ngIf="GradingModel=='Droplet Culture'">
                <!--<div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
                  <div class="row nav-link-hand margin-right-0px" id="edit-link">
                    <div class="col-md-6 padding-right-0px">
                      <label class="margin-bottom-0px font-size-16px font-weight-normal">
                        Insemination Log
                      </label>
                    </div>
                    <div class="col-md-6  padding-right-0px display-edit">

                      <div class="row float-right">

                        <div class="col-md-1">
                          <a class="nav-link-hand education-navlink data-color-new" title="print">
                            <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                          </a>
                        </div>
                      </div>




                    </div>

                  </div>
                </div>-->
                <div class="card-body padding-all-0px margin-left-0px">
                  <div class="accordion margin-bottom-20px margin-top-10" id="accordionExampleLog2">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingLog2">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseLog2" aria-expanded="true" aria-controls="collapseLog2">
                                Insemination Log
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="InseminationData2">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="button"
                                    class="btn  btn-sm button-ivfactivity  background-primary border-all-secondary float-right" id="FileUpload" (click)="Addactivity()"
                                    name="upload" *ngIf="InseminationData2.ActivityStatus !=='Completed'">
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                          </div>
                        </div>


                      </div>

                      <div id="collapseLog2" class="collapse show" aria-labelledby="headingLog2" data-parent="#accordionExampleLog2">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="card margin-bottom-0px background-lightpink">

                                <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                  <div class="table-component margin-bottom-0px padding-all-5px">
                                    <div class="table-responsive">


                                      <table class="table table-striped margin-left-zero overflow-y-hidden">

                                        <thead class="">
                                          <tr>
                                            <th class="min-width-0px">Date &amp; Time</th>

                                            <!--<th class="min-width-0px">No of times per hour</th>-->
                                            <th class="padding-left-5px">Done By</th>

                                            <th>Embryologist</th>
                                            <th></th>
                                          </tr>
                                        </thead>
                                        <tbody class="table-body">

                                          <tr *ngFor="let l of CurrentIvfCycleInseminationLogByCycleWithDOCController">
                                            <td class="td-padding">


                                              {{l.InseminationDate| date:'dd-MMM-yyyy'}} &amp; {{l.InseminationTimeText}}

                                            </td>
                                            <!--<td class="td-padding text-align-center">

                                              {{l.NtimesInformed}}


                                            </td>-->

                                            <td class="td-padding ">

                                              {{l.ProcessedByName}}
                                            </td>
                                            <td class="td-padding white-spce-pre">
                                              <div class="broder-right-1px-dark">{{l.DoctorName}}</div>
                                              <div>{{l.NurseName}}</div>
                                            </td>



                                            <td class="padding-top-0px padding-bottom-0px">
                                              <div class="test-icons float-right" *ngIf="InseminationData2">
                                                <!--<a (click)="Addactivity()" class="nav-link-hand font-size-16px" title="Remove" *ngIf="InseminationData2.ActivityStatus !=='Completed'"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>-->
                                                <a (click)="Editactivity(l)" class="nav-link-hand font-size-20px color-Assign" title="Edit" *ngIf="InseminationData2.ActivityStatus !=='Completed'">
                                                  <span class="badge"><i class="fas fa-pencil-alt nav-link-hand"></i></span>
                                                </a>
                                              </div>
                                            </td>

                                          </tr>


                                        </tbody>

                                      </table>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
